interface StatusBadgeProps {
  status: string
  size?: 'sm' | 'md'
}

const statusColors: Record<string, string> = {
  completed: 'bg-green-100 text-green-800 border-green-300',
  running: 'bg-blue-100 text-blue-800 border-blue-300',
  failed: 'bg-red-100 text-red-800 border-red-300',
  draft: 'bg-gray-100 text-gray-600 border-gray-300',
  pending: 'bg-yellow-100 text-yellow-800 border-yellow-300',
}

export function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const colors = statusColors[status] ?? statusColors['draft']
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1'

  return (
    <span className={`inline-flex items-center rounded-full border font-medium ${colors} ${sizeClass}`}>
      {status === 'running' && (
        <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-blue-600 animate-pulse" />
      )}
      {status}
    </span>
  )
}
